import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { DataRoleList } from "../../../components/DataRole";

export interface IDataRoleListPage {}

export const DataRoleListPage: FC<IDataRoleListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Data Roles"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'Data Roles', navigateTo: '/data-roles/list'}]}
      mainContents={<DataRoleList />}
    />
  );
};
